module.exports = __webpack_public_path__ + "static/media/PrideBrown.9de6ad1b.jpeg";